/**
 * Used in NotificationsPayload
 */
export enum NotificationTypeEnum {
  NEW_TASK = 'new-task',
  ASSIGNEE_CHANGE = 'assignee-change',
  STATUS_CHANGE = 'status-change',
  NEW_MESSAGE = 'new-msg',
  MESSAGE_REPLY = 'msg-reply',
  NEW_TASK_ASSIGNEE = 'new-task-assignee'
}